var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row padding-bottom-1 padding-top-1 question",
      class: _vm.cableSelection && "cable-wrapper",
    },
    [
      _vm._t("title", function () {
        return [
          _c(
            "div",
            {
              staticClass: "title",
              class: _vm.cableSelection && "cable-title",
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
        ]
      }),
      _vm._v(" "),
      _vm._t("subtitle", function () {
        return [
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.subtitle)),
          ]),
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "padding-top flex flex-wrap option-container" },
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            {
              key: option,
              class: `col xs-12 sm-12 md-4 flex flex-around offer ${
                option === _vm.selectedOption ? "active" : ""
              }`,
              attrs: { value: option },
              on: {
                click: function ($event) {
                  return _vm.onOptionClick(option)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(option) + "\n        ")]
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }